// @ts-nocheck
import omitMultiple from "@insite/mobius/utilities/omitMultiple";
import AccordionSection, { AccordionSectionProps } from "@store/MobiusOverrides/AccordionSection/AccordionSection";
import { useIsAccordionOpen } from "@toolkit/Framework/Store/Toolkit/Components/Accordion/AccordionHooks";
import createAccordionAnchor from "@toolkit/Framework/Store/Toolkit/Components/Accordion/Handlers/CreateAccordionAnchor";
import removeAccordionAnchor from "@toolkit/Framework/Store/Toolkit/Components/Accordion/Handlers/RemoveAccordionAnchor";
import setIsAccordionOpen from "@toolkit/Framework/Store/Toolkit/Components/Accordion/Handlers/SetIsAccordionOpen";
import React, { FC, PropsWithChildren, useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

export interface AnchoredAccordionProps extends AccordionSectionProps {
    anchorId: string;
    initialExpanded?: boolean;
    title: string;
}

const mapDispatchToProps = {
    createAccordionAnchor,
    removeAccordionAnchor,
    setIsAccordionOpen,
};

type Props = AnchoredAccordionProps & ResolveThunks<typeof mapDispatchToProps>;

const AnchoredAccordion: FC<PropsWithChildren<Props>> = ({
    anchorId,
    children,
    initialExpanded,
    title,
    createAccordionAnchor,
    removeAccordionAnchor,
    setIsAccordionOpen,
    ...otherProps
}) => {
    const isOpen = useIsAccordionOpen(anchorId);

    useEffect(() => {
        createAccordionAnchor({ id: anchorId, isOpen: initialExpanded });

        return () => {
            removeAccordionAnchor({ id: anchorId });
        };
    }, [anchorId]);

    const togglePanelHandler = () => {
        setIsAccordionOpen({ id: anchorId, isOpen: !isOpen });
    };

    return (
        <AccordionSection
            {...omitMultiple(otherProps, ["onTogglePanel", "expanded"])}
            accordionId={anchorId}
            expanded={isOpen}
            onTogglePanel={togglePanelHandler}
            title={title}
        >
            {children}
        </AccordionSection>
    );
};

export default connect(null, mapDispatchToProps)(AnchoredAccordion);
